import { render, staticRenderFns } from "./ConstructionPage.vue?vue&type=template&id=6bafaf09&scoped=true&"
import script from "./ConstructionPage.vue?vue&type=script&lang=js&"
export * from "./ConstructionPage.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionPage.vue?vue&type=style&index=0&id=6bafaf09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bafaf09",
  null
  
)

export default component.exports